module.exports = __webpack_public_path__ + "images/chart01.png";